import Marionette from "backbone.marionette";
import UsersTpl from "views/users/insertUserView.ejs";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({
    initialize: function() {

        $('#level_text_passww').hide();


        this.listenTo(S.mApp, "password:check", function(data) {

            if (data.perc >= 4)
                $("#c_pwd").prop("disabled", false);
            else
                $("#c_pwd").prop("disabled", true);
        });
    },
    template: UsersTpl,
    render: function() {
        this.$el.html(this.template({
            attributes: this.model.attributes,
            lang: this.collection.lang,
            available: this.collection.available,


            role: S.userInfo.attributes.role,
            ////// KO 
            ////// role: this.role 
            role_user: S.userInfo.attributes.role
        }));
        $("#insertModal").modal('show');

    },
    events: {
        "submit #insertUserForm": "save",
        "click #cancel": "cancel",
        "click #deletebtn": "delete",
        "change #role": "changeRole",
        "change #company": "changeCompany",
        "keyup #c_pwd": "confirmPwd",
        "change #pwd": "checkPwd",
        "keyup #pwd": "checkPwd"
    },
    save: function(ev) {
        ev.preventDefault();

        if ($("#pwd").val() && ($("#pwd").val() !== $("#c_pwd").val())) {
            S.mApp.trigger("notify:error", {
                message: S.userInfo.attributes.lang.PWD_UNMATCH
            });

            return false;
        }


        var formData = {};
        _.each(ev.target.elements, function(element) {
            if (element.nodeName === "BUTTON")
                return;
            if ($(element).attr("id") == "c_pwd")
                return;
            if ($(element).attr("id") == "pwd") {
                formData["password"] = $(element).val();
            } else {
                formData[$(element).attr("id")] = $(element).val();
            }
        });

        formData["company"] = S.companyId;

        this.model.save(formData, {
            beforeSend: T.useToken,
            success: function() {
                S.mApp.trigger("notify:success", {
                    message: S.userInfo.attributes.lang.INSERT_OK
                });

                S.mApp.trigger("update:users");
                $("#insertModal").modal('hide');
            },
            error: function() {
                S.mApp.trigger("notify:error", {
                    message: S.userInfo.attributes.lang.INSERT_ERROR
                });
                $("#insertModal").modal('hide');
            }
        });

        return false;
    },
    cancel: function() {
        $("#insertModal").modal("hide");
    },
    delete: function(ev) {
        //////var id_us = $('#deletebtn').attr("data_u");
        ev.preventDefault();
        $(ev.currentTarget).confirmation({
            rootSelector: "#deletebtn",
            placement: 'right',
            singleton: true,
            title: S.userInfo.attributes.lang.DELETE_CONFIRM,
            popout: true,
            onConfirm: function() {
                this.model.destroy({
                    success: function(model, response) {
                        if (!response) {
                            $("#insertModal").modal('hide');
                        }
                    }
                });
            },
            btnOkClass: 'btn-sm btn-danger',
            btnOkLabel: S.userInfo.attributes.lang.ACCEPT,
            btnCancelClass: 'btn-sm btn-default',
            btnCancelLabel: S.userInfo.attributes.lang.CANCEL,
        });
        $(ev.currentTarget).confirmation('show');

    },
    changeRole: function(ev) {
        if ($(ev.target).val() === "1") {
            $("#company").prop("disabled", true);
            $("#instanceId").prop("disabled", true);
        } else {
            $("#company").prop("disabled", false);
            $("#instanceId").prop("disabled", false);
        }
    },
    changeCompany: function(ev) {
        $("#instanceId").empty();
        _.each(this.collection.available, function(perm) {
            if ($(ev.target).val() !== perm.company)
                return;
            var selected = this.model.attributes.instanceId === perm.id ? 'selected' : '';
            $("#instanceId").append('<option value="' + perm.id + '" ' + selected + '>' + perm.instanceName + '</option>');
        }.bind(this));
    },
    confirmPwd: function(ev) {
        if ($("#pwd").val() !== $("#c_pwd").val()) {
            $("#post").prop("disabled", true);
        } else {
            $("#post").prop("disabled", false);
        }
    },
    checkPwd: function(ev) {
        var score = this.scorePassword($(ev.target).val());
        var perc = Math.min(4, Math.round((score / 60) * 4));

        var textoToView = "";
        if (perc <= 1) {
            $('#level_text_passww').text('Mala');
        } else if (perc > 1 && perc <= 3) {
            $('#level_text_passww').text('Regular');
        } else if (perc > 3) {
            $('#level_text_passww').text('Buena');
        }


        $('#level_text_passww').show();

        var porcenVal = perc;
        if (score <= 0) {
            porcenVal = "";
            $('#level_text_passww').hide();
        }




        $(".strength-meter-fill").attr("data-strength", porcenVal);
        S.mApp.trigger("password:check", {
            score: score,
            perc: perc
        });
    },
    scorePassword: function(pass) {
        var score = 0;
        if (!pass)
            return score;

        // award every unique letter until 5 repetitions
        var letters = new Object();
        for (var i = 0; i < pass.length; i++) {
            letters[pass[i]] = (letters[pass[i]] || 0) + 1;
            score += 5.0 / letters[pass[i]];
        }

        // bonus points for mixing it up
        var variations = {
            digits: /\d/.test(pass),
            lower: /[a-z]/.test(pass),
            upper: /[A-Z]/.test(pass),
            nonWords: /\W/.test(pass),
        }

        var variationCount = 0;
        for (var check in variations) {
            variationCount += (variations[check] == true) ? 1 : 0;
        }
        score += (variationCount - 1) * 10;

        return parseInt(score);
    }

});


//////////////////
// WEBPACK FOOTER
// ./app/views/users/insertUserView.js
// module id = 210
// module chunks = 0